import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './de.json';
import en from './en.json';

export const SUPPORTED_LANGUAGES = ['de', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = 'evalyte.admin.language';

/**
 * German unless somebody chose otherwise.
 *
 * The client and every user of this dashboard is German-speaking, so German is
 * the default rather than the browser's guess -- an English browser on a
 * German desk should still open in German. A choice made here outranks it and
 * survives a restart.
 */
function initialLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'de' || stored === 'en') return stored;
  } catch {
    /* No storage. German it is. */
  }
  return 'de';
}

void i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  lng: initialLanguage(),
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
});

export function setLanguage(language: Language) {
  void i18n.changeLanguage(language);
  document.documentElement.lang = language;
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    /* The change still applies for this session. */
  }
}

document.documentElement.lang = i18n.language;

export default i18n;
